import {Directive, ElementRef, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef} from "@angular/core";
import {isNullOrUndefined} from "util";
import {Roles, RoleService} from "../../core/security";

@Directive({
    selector: '[ifHasRoles]',
    providers: [RoleService]
})
export class HasRolesDirective implements OnInit, OnDestroy {
    private readonly elementTypes = ['input', 'select', 'button', 'a'];
    private hide: boolean;
    private route: string;
    private roles: string | Array<string> | Array<Roles>;

    @Input()
    set ifHasRoles(roles: string | Array<string> | Array<Roles>) {
        this.roles = roles;
    }

    @Input()
    set ifHasRolesHide(hide: boolean) {
        this.hide = hide;
    }

    /** Optional menu route to check exactly (see RoleService.hasExactRouteRoles) instead of the current URL. */
    @Input()
    set ifHasRolesRoute(route: string) {
        this.route = route;
    }

    constructor(
        private templateRef: TemplateRef<any>,
        private el: ElementRef,
        private viewContainerRef: ViewContainerRef,
        private roleService: RoleService
    ) {
    }

    ngOnDestroy(): void {
    }

    ngOnInit(): void {
        this.checkPermissions();
    }

    checkPermissions() {
        const allowed = isNullOrUndefined(this.route)
            ? this.roleService.hasRoles(this.roles)
            : this.roleService.hasExactRouteRoles(this.roles, this.route);
        if (!allowed) {
            this.hideOrDisabled();
        } else {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
    }

    private hideOrDisabled() {
        if (this.hide) {
            this.hideElements();
        } else {
            this.disabledElements();
        }
    }

    private disabledElements() {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
        if (!!this.el.nativeElement.nextSibling) {
            this.el.nativeElement.nextSibling.setAttribute('disabled', true);
            const nodes = this.el.nativeElement.nextSibling.querySelectorAll(this.elementTypes.join(','));
            if (!isNullOrUndefined(nodes) && nodes.length > 0) {
                nodes.forEach(node => {
                    node.setAttribute('disabled', true);
                });
            }
        }
    }

    private hideElements() {
        this.viewContainerRef.clear();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/directives/has-roles.directive.ts